import React from 'react';
import { ToggleSwitch } from '@shoflo-rundown/polymer.legacy';

export default React.createClass({
  displayName: 'PDFExportColumnVisibility',

  render() {
    return <div>{this._getColumnToggleNodes()}</div>;
  },

  _getColumnToggleNodes() {
    const {
      allColumns,
      includePrivateNoteContents,
      onColumnToggleClick,
      onPrivateNotesToggleClick,
    } = this.props;

    if (!allColumns) return null;

    return allColumns.map((column, columnId) => {
      const isItemNote = columnId === 'ItemNote';

      return (
        <div>
          <div className="pdf-options-toggle-option">
            <ToggleSwitch
              on={column.get('enabled')}
              onClick={() => {
                const visibility = !column.get('enabled');
                onColumnToggleClick(columnId, visibility);
              }}
            />
            <span className="column-title">{column.get('title')}</span>
          </div>
          {isItemNote && (
            <div>
              <div
                className="pdf-options-toggle-option-private-notes"
                onClick={() =>
                  onPrivateNotesToggleClick(includePrivateNoteContents)
                }
              >
                <input type="checkbox" checked={includePrivateNoteContents} />
                &nbsp;&nbsp;Include contents
              </div>
            </div>
          )}
        </div>
      );
    });
  },
});
